import { Component, Input } from '@angular/core';
import { Highlight } from 'ngx-highlightjs';
import { UilabMatButton } from '@uilab/ng-mat-components';

@Component({
    selector: 'avd-code-example',
    templateUrl: './code-example.component.html',
    styleUrls: ['./code-example.component.scss'],
    imports: [Highlight, UilabMatButton],
})
export class CodeExampleComponent {
    @Input() label: string = '';
    @Input() description: string = '';
    @Input() htmlSnippet: string = '';
    @Input() tsSnippet?: string;
    @Input() storybookLink?: string;
    @Input() repoLink?: string;
    @Input() noPadding?: boolean;

    showCode = false;
    activeTab: 'html' | 'ts' = 'html';

    toggleCode(): void {
        this.showCode = !this.showCode;
        if (!this.showCode) {
            this.activeTab = 'html';
        }
    }
}
